import Logo from "../../../../assets/images/logo.png";
import "./Welcome.scss";
const Welcome = () => {
  return (
    <section className="welcome d-flex justify-content-center align-items-center position-fixed w-100 h-100">
      <img
        className="logo position-relative"
        src={Logo}
        alt="dynamic-chart.png"
        draggable={false}
      />
    </section>
  );
};
export default Welcome;
